import { render, staticRenderFns } from "./ContactInfo.vue?vue&type=template&id=d63424ca&scoped=true&"
import script from "./ContactInfo.vue?vue&type=script&lang=js&"
export * from "./ContactInfo.vue?vue&type=script&lang=js&"
import style0 from "./ContactInfo.vue?vue&type=style&index=0&id=d63424ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d63424ca",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ChatContactAvatar: require('/home/circleci/repo/components/chat/ChatContactAvatar.vue').default})
